import { Flex, Text } from '@chakra-ui/react';

import { IAlertMessage } from 'api/Models';

export function SubscriptionGate({ alert }: { alert: IAlertMessage }): JSX.Element {
  return (
    <Flex justify-content='center' align-items='center' w='100%' gap='117px'>
      <Flex direction='column' max-w='684px'>
        <Text font-weight='700' line-height='44px' font-size='36px'>
          {alert.title}
        </Text>
        <Text
          font-weight='400'
          line-height='24px'
          font-size='16px'
          dangerouslySetInnerHTML={{ __html: alert.description }}
          sx={{
            a: {
              textDecoration: 'underline',
            },
          }}
        />
      </Flex>
      <Flex
        background-color='yellow.50'
        border-width='2px'
        border-color='yellow.200'
        border-radius='50%'
        width='230px'
        height='230px'
        align-items='center'
        justify-content='center'
      />
    </Flex>
  );
}
